export default "__VITE_ASSET__6135a316__"